// Time formatting helpers
export function to12hr(time24) {
  if (!time24 || typeof time24 !== "string") return time24 || "";
  const [hStr, mStr = "00"] = time24.split(":");
  let h = parseInt(hStr, 10);
  if (isNaN(h)) return time24;
  const ampm = h >= 12 ? "PM" : "AM";
  h = h % 12;
  if (h === 0) h = 12;
  const m = mStr.padStart(2, "0");
  return m === "00" ? `${h}${ampm}` : `${h}:${m}${ampm}`;
}

export function formatTimeRange(start, end) {
  return `${to12hr(start)} – ${to12hr(end)}`;
}

export function weekdayName(isoDate) {
  if (!isoDate) return "";
  const d = new Date(isoDate + "T00:00:00");
  return d.toLocaleDateString("en-US", { weekday: "long" });
}

export function shortMonth(isoDate) {
  if (!isoDate) return "";
  const d = new Date(isoDate + "T00:00:00");
  return d.toLocaleDateString("en-US", { month: "short" }).toUpperCase();
}

export function dayNum(isoDate) {
  if (!isoDate) return "";
  return String(new Date(isoDate + "T00:00:00").getDate()).padStart(2, "0");
}

export function prettyDate(isoDate) {
  if (!isoDate) return "";
  const d = new Date(isoDate + "T00:00:00");
  return d.toLocaleDateString("en-US", { month: "long", day: "numeric", year: "numeric" });
}
